import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';

@Component({
    selector: 'app-test-markets',
    templateUrl: './test-markets.component.html',
    styleUrls: ['./test-markets.component.scss'],
    animations: [
        trigger('slider', [
            state('*', style({
                height: 0
            })),
            state('show', style({
                height: '*'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class TestMarketsComponent implements OnInit {

  markets: ValueIdPair[] = [];
  selectedTestMarket: TestGeneralMarket;
  isSelectedMarket: boolean = false;

  constructor(public service: AppService, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient) { }

  ngOnInit() {
    if (this.service.currentUser.isTestingEnabled === true) {
      this.GetMarkets();
    }
  }

  /** List all the markets */
  GetMarkets() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/testContributions/getMarkets').subscribe(result => {
      this.markets = result;
    }, error => {
      console.error(error);
    });
  }

  /** Gets the selected market details */
  GetMarket(marketId: string) {
    this.http.get<TestGeneralMarket>(this.baseUrl + 'api/testContributions/getMarket/' + marketId).subscribe(result => {
      this.selectedTestMarket = result;
      this.isSelectedMarket = true;
    }, error => {
      console.error(error);
    });
  }

  /** Change event for the market select */
  OnChangeMarket(marketId: string) {
    this.GetMarket(marketId);
  }

  /** Click event for the reset button */
  OnClickReset() {
    this.http.post<GRSSResponse>(this.baseUrl + 'api/testContributions/resetMarket', this.selectedTestMarket).subscribe(result => {
      if (result.statusCode === 4) {
        this.service.SaveStatus(true, 'Reset Test Bed', result.statusMessage);
      } else {
        this.service.SaveStatus(false, 'Reset Test Bed', result.statusMessage);
      }
    }, error => {
      console.error(error);
    });
  }

  /** Click event for the save button */
  OnClickSave() {
    this.http.post<GRSSResponse>(this.baseUrl + 'api/testContributions/updateTesting', this.selectedTestMarket).subscribe(result => {
      if (result.statusCode === 4) {
        this.service.SaveStatus(true, 'Update Test Bed', result.statusMessage);
      } else {
        this.service.SaveStatus(false, 'Update Test Bed', result.statusMessage);
      }
    }, error => {
      console.error(error);
    });
  }

}

/** An interface to access market details */
interface TestGeneralMarket {
  marketId: string;
  enabled: boolean;
  contributorRangeMin: number;
  contributorRangeMax: number;
  instruments: TestInstrument[];
}

/** An interface to access an instrument details */
interface TestInstrument {
  instrumentId: string;
  instrumentName: string;
  rateMin: number;
  rateMax: number;
  hasVolume: boolean;
  volumeMin: number;
  volumeMax: number;
}
